"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _brandSelection = require("@/api/brandSelection");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: [],
  data: function data() {
    return {
      showBoole: false,
      categoryOption: [],
      dialogVisible1: false,
      popTitle: '',
      fileList: [],
      ruleForm: {
        id: '',
        opType: 1,
        categoryId: '',
        brandName: '',
        logoUrl: '',
        ossUrl: '',
        status: 1,
        fileName: ''
      },
      options: [],
      rules: {
        categoryId: [{
          required: true,
          message: '请选择类目',
          trigger: 'change'
        }],
        brandName: [{
          required: true,
          message: '请输入品牌名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.ruleForm.ossUrl = '';
      this.ruleForm.fileName = '';
    },
    down: function down() {
      window.location.href = 'https://ugcore.oss-cn-hangzhou.aliyuncs.com/template/%E5%93%81%E7%89%8C%E7%B2%BE%E9%80%89%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx';
    },
    handleFileUpload1: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file, 'import');
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.ossUrl = pictureUrl;
              this.fileList = [{
                name: file.name,
                url: pictureUrl
              }];
              this.ruleForm.fileName = file.name;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message({
                message: '上传失败',
                type: 'error'
              });
              this.handleRemove();
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload1(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload1;
    }(),
    handleFileUpload: function () {
      var _handleFileUpload2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref2) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref2.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.logoUrl = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload(_x2) {
        return _handleFileUpload2.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    get_categoryselect: function get_categoryselect() {
      var _this = this;
      (0, _brandSelection.categoryselect)({}).then(function (res) {
        _this.categoryOption = res.data;
      });
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.type === 'add' ? '新增品牌信息' : '编辑品牌信息';
      this.showBoole = data.type === 'add';
      this.get_categoryselect();
      if (data.type === 'upDate') {
        this.ruleForm = {
          id: data.id,
          opType: 1,
          categoryId: data.categoryId,
          brandName: data.brandName,
          logoUrl: data.logoUrl,
          ossUrl: data.ossUrl || null,
          status: data.status
        };
      } else {
        this.clearIt();
      }
      this.dialogVisible1 = true;
    },
    clearIt: function clearIt() {
      this.ruleForm = {
        id: '',
        opType: 1,
        categoryId: '',
        brandName: '',
        logoUrl: '',
        ossUrl: '',
        status: 1,
        fileName: ''
      };
      this.fileList = [];
    },
    onClose: function onClose() {
      this.clearIt();
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible1 = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this2.ruleForm);
          (0, _brandSelection.save_brand)((0, _objectSpread2.default)({}, _this2.ruleForm)).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.onClose();
              _this2.$emit('refresh');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.fileList = [];
      this.$refs[formName].resetFields();
    }
  }
};